// React
import { useEffect, useState } from "react"

// Types
import type { SuccessFetch } from "types"
import type { FormType } from "components/widgets/DashboardFilter/utils"

// Utils
import { useApi } from "utils"

// Types
interface Type {
  invoice_id: number
  trx_code: string
  transaction_date: string
  sales_order: {
    sales_order_id: number
    trx_code: string
    referesi: string
  },
  customer: {
    customer_name: string
    customer_id: number
    customer_code: string
  },
  balance: number
  aged_receivable: number
}

export function useReceivableList(params?: FormType) {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<Type[]>([])
  const [isLoading, setLoading] = useState<boolean>(false)

  const refetch = (params: FormType): void => {
    setLoading(true)

    api.get(
      "/dashboard/transaction/account-receivable/",
      {
        params: {
          ...params,
          location_id: params.location_id !== "" ? params.location_id : null
        }
      }
    ).then((res: SuccessFetch<{ payload: Type[] }>) => {
      setData(res.data.payload)
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
  }

  useEffect(() => {
      setLoading(true)
  
      api.get(
        "/dashboard/transaction/account-receivable/",
        {params: {
          ...params,
          location_id: params?.location_id !== "" ? params?.location_id : null
        }}
      )
      .then((res: SuccessFetch<{ payload: Type[] }>) => setData(res.data.payload))
      .catch(() => setData([]))
      .finally(() => setLoading(false))
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { data, isLoading, refetch }
}